// extracted by mini-css-extract-plugin
export var arrows = "_6k-5";
export var decrementer = "_6k-9";
export var disabled = "_6k-3";
export var error = "_6k-1";
export var hiddenText = "_6k-a";
export var incrementer = "_6k-8";
export var input = "_6k-7";
export var inputWrapper = "_6k-0";
export var leadingIcon = "_6k-b";
export var readonly = "_6k-2";
export var regular = "_6k-6";
export var small = "_6k-4";